import { createContext, useContext, useEffect } from 'react'
import * as _ from 'lodash-es'
import { useRouter } from 'next/router'
import { useQueryNext } from './hooksF/useQueryNextF'
import Cookies from 'js-cookie'
import { gqGetUserToken } from './gqlF/authLinkF'
import { NoSSRWrapper } from './NoSSRWrapperF'
import { SsidWrapper } from './SessIdWrapF'
import { userTokenKey } from '../sharedF/cookiesF.mts'
import { userTokUrlParamName } from '../sharedF/authF/constantsF.mts'
import { PtSiteCtx } from './CustomSiteF/CustomSiteWrapperF'
import { ManualClientSideExceptionWrap } from './ManualClientSideExceptionWrapF'
import { useRefetchAll } from './hooksF/refetch1AllF.js'

export const UserAuthContext = createContext(/** @type {any} */ (undefined))
export const LoginDaysCtx = createContext(/** @type {number | undefined} */ (undefined))

export const UserAuthWrapper = (/** @type {any} */ {children, skipUserAuth}) => {
  if (skipUserAuth) return children
  return <NoSSRWrapper>
    <ManualClientSideExceptionWrap>
      {/* doubled with MinPageTemplate, should only have 1 */}
      {/* <SsidWrapper> */}
        <UserAuthWrapperInner {...{children}} />
      {/* </SsidWrapper> */}
    </ManualClientSideExceptionWrap>
  </NoSSRWrapper>
}

export const useSaveUserTok = () => {
  const loginForDays = useContext(LoginDaysCtx) || 365
  const {refetchAll} = useRefetchAll()

  const do2SaveUserTok = ({gqUserTok}) => {
    // doSaveUserTok({gqUserTok, expires: loginForDays})
    Cookies.set(userTokenKey, gqUserTok, { expires: loginForDays, sameSite: 'strict' })
    refetchAll()
  }
  return {do2SaveUserTok}
}

export const useFncOnLogin = (fnc) => {
  const origTok = Cookies.get(userTokenKey)
  useEffect(() => {
    const intervalFnc = () => {
      const newTok = Cookies.get(userTokenKey)
      if (origTok != newTok) {
        fnc()
      }
    }
    const ii = setInterval(intervalFnc, 2 * 1000)
    return () => clearInterval(ii)
  }, [])
}

export const useReloadOnLogin = () => {
  return useFncOnLogin(() => {location.reload()})
}

export const doRmCookie = () => Cookies.remove(userTokenKey)

const doSignout = doRmCookie

export const use2SignOut = () => {
  // const ap = useApollo()
  const doSignout = () => {
    doRmCookie()
    // ap.resetStore()
    // ap.refetchQueries({include: 'all'})
  }
  return {doSignout}
}

const UserAuthWrapperInner = ({children}) => {
  const router = useRouter() || {query: {}}

  const {do2SaveUserTok} = useSaveUserTok()

  let {query, pathname} = router

  let gqUserTok = query[userTokUrlParamName] || query.ut

  if (!_.includes(pathname, `[${userTokUrlParamName}]`)) {
    if (gqUserTok) {
      do2SaveUserTok({gqUserTok})

      const newHref = _.replace(location.href, `${userTokUrlParamName}=${gqUserTok}`, '')
      history.replaceState(null, '', newHref)
    } else {
      gqUserTok = gqGetUserToken()
    }
  }

  return <UserAuthWrapperFetch {...{gqUserTok, children}} />
}

export const useFetchUser = ({gqUserTok}) => {
  const {UserAuthQuery} = useContext(PtSiteCtx)
  const {data, loading, error} = useQueryNext(UserAuthQuery, {
    skip: !gqUserTok, variables: {gqUserTok}
  })

  if (error) {
    console.log(error)
  }

  const user = _.values(data)[0]

  const value = {
    isLoggedIn: !!user,
    ...user,
    isLoading: loading, loading,
    gqUserTok,
  }

  return value
}

export const UserAuthWrapperFetch = ({gqUserTok, children}) => {
  const value = useFetchUser({gqUserTok})
  return <UserAuthContext.Provider {...{value, children}} />
}

